import React from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import Action from 'actions';
import Const from 'constants';
import {calcSympathyPoints} from 'helpers/player-helper';
import {PlayerSympathy} from './index';

class FlexRankPlayerSympathy extends PlayerSympathy {
    onChange(value) {
        this.updatePlayerSympathy(value);
        this.updateUserPoints(value);

        this.onClick(false);
    }

    updatePlayerSympathy(value) {
        const {modesConfig, playerId} = this.props;

        const playerSympathyByMode = {};
        modesConfig.all({asArr: true}).map((modeConfig) => {
            playerSympathyByMode[modeConfig.getRole()] = {
                [playerId]: value,
            };
        });

        this.props.dispatch(Action.set('PlayersSympathy', playerSympathyByMode));
    }

    updateUserPoints(value) {
        const {modesConfig, userPointsType} = this.props;

        const player = this.getPlayer();

        modesConfig.all({asArr: true}).map((modeConfig) => {
            let userPoints = calcSympathyPoints(
                player.getPropValueOfMode(userPointsType.getUserPointsType(), modeConfig.getRole()),
                Const.SYMPATHIES_LIST[value],
            );
            userPoints = NumberHelper.float(userPoints, 3);

            this.props.dispatch(
                Action.set(
                    'UserPoints',
                    [
                        {
                            playerId: player.getId(),
                            userPoints,
                        },
                    ],
                    modeConfig.getRole(),
                    false,
                ),
            );
        });
    }

    getMode() {
        return Const.FLEX_MODE;
    }
}

function mapStatesToProps(state) {
    const {playersData, playerSettingPopup, modesConfig, playersSympathy, userPointsType} = state;

    return {
        players: playersData.players,
        playerSettingPopup,
        modesConfig,
        playersSympathy,
        userPointsType,
    };
}

export default connect(mapStatesToProps)(FlexRankPlayerSympathy);
